import type { ReactNode } from "react";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import useIsNewOnboardingFlow from "../hooks/useIsNewOnboardingFlow";
import { OnboardingLayout } from "./OnboardingLayout";
import { OnboardingSplitLayout } from "./OnboardingSplitLayout/index";

export interface OnboardingWrapperProps {
  children: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  step?: string;
  progress?: {
    new: {
      currentStep: number;
      totalSteps: number;
    };
    legacy: string;
  };
  isNarrow?: boolean;
  withCircleBranding?: boolean;
  shouldShowPoweredByCircle?: boolean;
  isVerticallyCenteredOnMobile?: boolean;
  background?: "dark" | "light" | "discover";
  rightPanel?: ReactNode;
  isRegisteringAsACommunityMember?: boolean;
}

export const OnboardingWrapper = ({
  children,
  title,
  subtitle,
  step,
  progress,
  isNarrow = false,
  withCircleBranding = true,
  shouldShowPoweredByCircle = false,
  isVerticallyCenteredOnMobile = false,
  background = "dark",
  rightPanel,
  isRegisteringAsACommunityMember = false,
}: OnboardingWrapperProps) => {
  const { currentCommunity } = useCurrentCommunityContext();
  const isNewOnboardingFlow = useIsNewOnboardingFlow();

  if (!isNewOnboardingFlow || isRegisteringAsACommunityMember) {
    return (
      <OnboardingLayout
        community={currentCommunity}
        title={title}
        subtitle={subtitle}
        step={step}
        progress={progress?.legacy}
        isNarrow={isNarrow}
        withCircleBranding={withCircleBranding}
        shouldShowPoweredByCircle={shouldShowPoweredByCircle}
        isVerticallyCenteredOnMobile={isVerticallyCenteredOnMobile}
        background={background}
      >
        {children}
      </OnboardingLayout>
    );
  }

  return (
    <OnboardingSplitLayout
      title={title}
      subtitle={subtitle}
      progress={progress?.new}
      rightPanel={rightPanel}
    >
      {children}
    </OnboardingSplitLayout>
  );
};
